import { useDispatch } from 'react-redux';
import type { ThunkDispatch } from 'state/state.common';

export function useThunkDispatch() {
  return useDispatch<ThunkDispatch>();
}
